import React from 'react';
import loadable from '@loadable/component';
import { Spin } from '@arco-design/web-react';
import styles from '../style/layout.module.less';

function LoadingComponent() {
  return (
    <div className={styles.spin}>
      <Spin />
    </div>
  );
}

// 简化的懒加载包装器
export default (importFunc) => {
  const LazyComponent = loadable(importFunc, {
    fallback: <LoadingComponent />,
  });

  // 保留preload方法的兼容性
  LazyComponent.preload = importFunc;

  return LazyComponent;
};
